module.exports = __webpack_public_path__ + "img/caper.d202820b.jpg";